module.exports = __webpack_public_path__ + "img/24.a7cd470b.png";